import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { useUserContext } from '../../../../../../context/UserProvider'
import { useNavigate } from 'react-router-dom'
import fuelReportTableColumns from './fuelReportColumns'
import type { Fuel } from '../../../../../../types'
import type { Row } from '@tanstack/react-table'
import { formatNumber } from '../../../utils/formatNumber'
import { formatCurrency } from '../../../utils/formatCurrency'

type FuelReportTableProps = {
  data: any
  isLoading?: boolean
}

function FuelReportTable({ data, isLoading }: FuelReportTableProps) {
  //@ts-expect-error - remove this when UserContext is type safe
  const { chosenCompany, handleSetConsolidateInvoice } = useUserContext()
  const columns = fuelReportTableColumns({ chosenCompany, handleSetConsolidateInvoice })

  return (
    <GenericTable
      className="max-h-[50vh]"
      data={data}
      isLoading={isLoading}
      columns={columns}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} handleSetConsolidateInvoice={handleSetConsolidateInvoice} />
      }}
    />
  )
}

export default FuelReportTable

function MobileCardContent({
  row,
  handleSetConsolidateInvoice,
}: {
  row: Row<Fuel>
  handleSetConsolidateInvoice: (value: string) => void
}) {
  const navigate = useNavigate()

  const { tyear, tmonth, volume, amountIncVAT, consolidatedInvoiceAgreement } = row.original

  const header = `${tyear} - ${tmonth}`
  const data = [
    {
      label: 'Samlefakturakode',
      value: consolidatedInvoiceAgreement,
    },
    {
      label: 'Beløp',
      value: formatCurrency(amountIncVAT),
    },
    {
      label: 'Mengde',
      value: formatNumber(volume, { digits: { min: 0, max: 0 } }),
    },
  ]

  const action = {
    onClick: () => {
      handleSetConsolidateInvoice(consolidatedInvoiceAgreement)
      navigate(`/reports/fuel/${tyear}-${tmonth}`)
    },
  }

  return <TableMobileCardContent header={header} data={data} action={action} />
}
